var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 423,
    viewBox: "0 0 393 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2229_3686",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 393,
    height: 423
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 423,
    transform: "matrix(1 0 0 -1 0 423)",
    fill: "url(#paint0_linear_2229_3686)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2229_3686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393 211.5L393 0L0 -1.075e-05L-1.47736e-05 211.5L393 211.5Z",
    fill: "url(#paint1_linear_2229_3686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.47736e-05 211.5L0 423L393 423L393 211.5L-1.47736e-05 211.5Z",
    fill: "url(#paint2_linear_2229_3686)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2229_3686",
    x1: 196.5,
    y1: 0,
    x2: 196.5,
    y2: 423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2229_3686",
    x1: 393,
    y1: 0,
    x2: 393,
    y2: 211.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0909091,
    stopColor: "#0048FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181818,
    stopColor: "#0064FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272727,
    stopColor: "#0079FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363636,
    stopColor: "#008CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454545,
    stopColor: "#009DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545455,
    stopColor: "#00ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636364,
    stopColor: "#00BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727273,
    stopColor: "#00CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818182,
    stopColor: "#00D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909091,
    stopColor: "#00E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2229_3686",
    x1: 0,
    y1: 423,
    x2: -0.00000578528,
    y2: 211.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0909091,
    stopColor: "#5FFF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181818,
    stopColor: "#36FF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272727,
    stopColor: "#00FF81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363636,
    stopColor: "#00FF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454545,
    stopColor: "#00FFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545455,
    stopColor: "#00FFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636364,
    stopColor: "#00FDD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727273,
    stopColor: "#00FAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818182,
    stopColor: "#00F7F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909091,
    stopColor: "#00F4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.c2c538facbf5c8129586f2d7b4aca7c4.svg";
export { ForwardRef as ReactComponent };